import { useParams } from "react-router-dom"
import { UserReportCard } from "../../path/report/UserReportCard"

function ProfileRegistrationReportCardAugmentation() {
  const { pathId } = useParams<{
    pathId: string
  }>()

  return <UserReportCard pathId={parseInt(pathId)} />
}

export default ProfileRegistrationReportCardAugmentation
